var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessonBlockedIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 9.5,
    stroke: "#98BDBD",
    strokeDasharray: "2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2167_5698)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2167_5698)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3337 27.5003C16.1915 27.5003 12.8337 24.1425 12.8337 20.0003C12.8337 18.2692 13.4202 16.675 14.4054 15.4057L24.9283 25.9286C23.659 26.9138 22.0648 27.5003 20.3337 27.5003ZM26.3317 24.5036C27.2748 23.2496 27.8337 21.6902 27.8337 20.0003C27.8337 15.8582 24.4758 12.5003 20.3337 12.5003C18.6438 12.5003 17.0844 13.0592 15.8304 14.0022L26.3317 24.5036ZM11.167 20.0003C11.167 25.0629 15.271 29.167 20.3337 29.167C25.3963 29.167 29.5003 25.0629 29.5003 20.0003C29.5003 14.9377 25.3963 10.8337 20.3337 10.8337C15.271 10.8337 11.167 14.9377 11.167 20.0003Z",
    fill: "#98BDBD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2167_5698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2167_5698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 30) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonBlockedIc);
export default __webpack_public_path__ + "static/media/lesson_blocked_ic.ae22aca93092dcc981d93a02c800cb5b.svg";
export { ForwardRef as ReactComponent };